module.exports = __webpack_public_path__ + "img/paystar.9bcb6a20.png";